import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from '../newbuilding';

export function selectGaLabel(state: IApplicationState): string {
  const newbuilding = selectNewbuilding(state);

  return newbuilding.customPageUrl || '';
}
